import { ApiClient } from 'ApiClient';
import { MenuSection } from 'interfaces';

class MenuCategoryService {
  public async get(menuSectionId: string): Promise<MenuSection> {
    const response: MenuSection = await ApiClient.get<MenuSection>(
      `menu-sections/${menuSectionId}`,
    );

    return response;
  }

  public save({ id, data }: { id?: number; data: any }) {
    if (id) {
      return ApiClient.put(`menu-categories/${id}`, data);
    }

    return ApiClient.post('menu-categories', data);
  }

  public delete(id: number) {
    return ApiClient.delete(`menu-categories/${id}`);
  }
}

const singleton = new MenuCategoryService();

export { singleton as MenuCategoryService };
